export function isQuery(string: string) {
  let queryPattern = /^\??[^=&]*=[^=&]*(?:&[^=&]*=[^=&]*)*$/;

  return queryPattern.test(string);
}
